module.exports = __webpack_public_path__ + "img/logo.a544289c.png";